import { render, staticRenderFns } from "./KelasOnlineEdit.vue?vue&type=template&id=deff10c4&scoped=true"
import script from "./KelasOnlineEdit.vue?vue&type=script&lang=js"
export * from "./KelasOnlineEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deff10c4",
  null
  
)

export default component.exports